export default __webpack_public_path__ + "static/media/employeeManagement (1).5014d14c.png";